import { useState } from 'react';
import { useDndMonitor } from '@dnd-kit/core';

export type DropLocationProps = {
	id: string;
	color: string;
	dragOverColor: string;
	children: React.ReactNode;
};

export const DropLocation = ({
	id,
	color,
	dragOverColor,
	children,
}: DropLocationProps) => {
	const [isDraggingOver, setIsDraggingOver] = useState(false);

	useDndMonitor({
		onDragStart: () => setIsDraggingOver(false),
		onDragOver: event => setIsDraggingOver(!!event.over),
		onDragEnd: () => setIsDraggingOver(false),
		onDragCancel: () => setIsDraggingOver(false),
	});

	const style = {
		background: isDraggingOver ? dragOverColor : color,
	};

	return <div style={style}>{children}</div>;
};
